module.exports = __webpack_public_path__ + "img/right.f463fdad.png";